// Granite Peak Manufacturing - Reference Library page logic
(function (global) {
'use strict';
var GPM = global.GPM;

var PLACEHOLDER_MATERIALS = [
  { name: 'Aluminum 6061-T6', category: 'Non-Ferrous', hardness: '95 BHN', machinability: 'Excellent', sfm: '800–1000' },
  { name: 'Aluminum 7075-T6', category: 'Non-Ferrous', hardness: '150 BHN', machinability: 'Good', sfm: '600–800' },
  { name: 'Mild Steel 1018', category: 'Carbon Steel', hardness: '126 BHN', machinability: 'Good', sfm: '300–400' },
  { name: '4140 Alloy Steel', category: 'Alloy Steel', hardness: '197 BHN', machinability: 'Fair', sfm: '200–350' },
  { name: 'Stainless 304', category: 'Stainless', hardness: '201 BHN', machinability: 'Poor', sfm: '100–200' },
  { name: 'Stainless 316', category: 'Stainless', hardness: '217 BHN', machinability: 'Poor', sfm: '80–180' },
  { name: 'Tool Steel D2', category: 'Tool Steel', hardness: '217 BHN', machinability: 'Difficult', sfm: '50–120' },
  { name: 'Ti-6Al-4V', category: 'Titanium', hardness: '334 BHN', machinability: 'Difficult', sfm: '50–100' },
  { name: 'Cast Iron (Gray)', category: 'Cast Iron', hardness: '187 BHN', machinability: 'Good', sfm: '250–400' },
  { name: 'Inconel 718', category: 'Superalloy', hardness: '331 BHN', machinability: 'Very Difficult', sfm: '25–70' },
  { name: 'Brass 360', category: 'Non-Ferrous', hardness: '78 BHN', machinability: 'Excellent', sfm: '800–1200' },
  { name: 'Delrin / POM', category: 'Plastic', hardness: 'N/A', machinability: 'Excellent', sfm: '500–1000' }
];

var PLACEHOLDER_TOOLS = [
  { name: 'Flat End Mill', flutes: '2–4', materials: 'All', use: 'Profiling, Slotting, Pocketing' },
  { name: 'Ball End Mill', flutes: '2–4', materials: 'All', use: '3D Contouring, Finishing' },
  { name: 'Bull Nose End Mill', flutes: '3–5', materials: 'All', use: 'Semi-finish, Floor Blends' },
  { name: 'Face Mill', flutes: '4–8', materials: 'Steels, Cast Iron', use: 'Face Milling, Stock Removal' },
  { name: 'Drill', flutes: '2', materials: 'All', use: 'Hole Making' },
  { name: 'Chamfer Mill', flutes: '2–4', materials: 'All', use: 'Chamfering, Deburring' },
  { name: 'Thread Mill', flutes: '1–3', materials: 'All', use: 'Thread Milling' },
  { name: 'Roughing End Mill', flutes: '4–6', materials: 'Steels, Aluminum', use: 'Heavy Stock Removal' },
  { name: 'Reamer', flutes: '4–6', materials: 'All', use: 'Hole Finishing' },
  { name: 'Spot Drill', flutes: '2', materials: 'All', use: 'Hole Starting, Chamfering' }
];

var PLACEHOLDER_DATA = [
  { material: 'Aluminum 6061', tool: 'Carbide End Mill', sfm: '800', chipLoad: '0.003', doc: '1.0xD', woc: '0.5xD' },
  { material: 'Aluminum 7075', tool: 'Carbide End Mill', sfm: '700', chipLoad: '0.0025', doc: '1.0xD', woc: '0.45xD' },
  { material: 'Mild Steel 1018', tool: 'Carbide End Mill', sfm: '350', chipLoad: '0.002', doc: '0.5xD', woc: '0.3xD' },
  { material: '4140 Alloy', tool: 'Carbide End Mill', sfm: '275', chipLoad: '0.0018', doc: '0.5xD', woc: '0.25xD' },
  { material: 'Stainless 304', tool: 'Carbide End Mill', sfm: '150', chipLoad: '0.0015', doc: '0.3xD', woc: '0.2xD' },
  { material: 'Ti-6Al-4V', tool: 'Carbide End Mill', sfm: '80', chipLoad: '0.001', doc: '0.25xD', woc: '0.15xD' },
  { material: 'Cast Iron', tool: 'Carbide End Mill', sfm: '350', chipLoad: '0.002', doc: '0.5xD', woc: '0.35xD' },
  { material: 'Brass 360', tool: 'Carbide End Mill', sfm: '900', chipLoad: '0.004', doc: '1.0xD', woc: '0.5xD' }
];

var badgeClass = {
  'Excellent': 'badge-excellent', 'Good': 'badge-good', 'Fair': 'badge-fair',
  'Poor': 'badge-poor', 'Difficult': 'badge-difficult', 'Very Difficult': 'badge-very-difficult',
  'Custom': 'badge-custom'
};

var state = { search: '', category: 'all', tab: 'materials' };

function esc(s) { return GPM.esc(s); }

function renderMaterials() {
  var custom = GPM.getCustomMaterials().map(function (m) {
    return {
      name: m.name, category: m.category || 'Custom',
      hardness: m.hardness_hb ? m.hardness_hb + ' HB' : 'N/A',
      machinability: m.machinability || 'Custom',
      sfm: m.sfm_range || '—', id: m.id, isCustom: true
    };
  });
  var rows = custom.concat(PLACEHOLDER_MATERIALS);
  var q = state.search.toLowerCase();
  var filtered = rows.filter(function (m) {
    var matchSearch = !q || m.name.toLowerCase().indexOf(q) !== -1 || m.category.toLowerCase().indexOf(q) !== -1;
    var matchCat = state.category === 'all' || m.category === state.category;
    return matchSearch && matchCat;
  });
  var body = filtered.map(function (m) {
    return '<tr><td class="name">' + esc(m.name) + '</td><td>' + esc(m.category) + '</td>'
      + '<td class="mono">' + esc(m.hardness) + '</td>'
      + '<td><span class="gpm-badge ' + (badgeClass[m.machinability] || 'badge-custom') + '">' + esc(m.machinability) + '</span></td>'
      + '<td class="accent">' + esc(m.sfm) + '</td>'
      + '<td class="right">' + (m.isCustom ? '<button class="gpm-btn-danger" data-del-material="' + esc(m.id) + '" aria-label="Delete ' + esc(m.name) + '"><span data-icon-inline>' + GPM.icons.trash + '</span></button>' : '') + '</td></tr>';
  }).join('');
  document.getElementById('gpm-materials-body').innerHTML = body;
  document.getElementById('gpm-materials-empty').style.display = filtered.length ? 'none' : '';
  document.querySelectorAll('[data-del-material]').forEach(function (btn) {
    btn.querySelector('svg').style.width = '14px';
    btn.querySelector('svg').style.height = '14px';
    btn.addEventListener('click', function () {
      var id = btn.getAttribute('data-del-material');
      GPM.saveCustomMaterials(GPM.getCustomMaterials().filter(function (m) { return String(m.id) !== String(id); }));
      renderMaterials();
    });
  });
}

function renderTools() {
  var q = state.search.toLowerCase();
  var filtered = PLACEHOLDER_TOOLS.filter(function (t) {
    return !q || t.name.toLowerCase().indexOf(q) !== -1 || t.use.toLowerCase().indexOf(q) !== -1;
  });
  document.getElementById('gpm-tools-body').innerHTML = filtered.map(function (t) {
    return '<tr><td class="name">' + esc(t.name) + '</td><td class="mono">' + esc(t.flutes) + '</td><td>' + esc(t.materials) + '</td><td style="color:var(--shop-light);">' + esc(t.use) + '</td></tr>';
  }).join('');
  document.getElementById('gpm-tools-empty').style.display = filtered.length ? 'none' : '';
}

function renderCuttingData() {
  var q = state.search.toLowerCase();
  var filtered = PLACEHOLDER_DATA.filter(function (d) {
    return !q || d.material.toLowerCase().indexOf(q) !== -1 || d.tool.toLowerCase().indexOf(q) !== -1;
  });
  document.getElementById('gpm-cutting-body').innerHTML = filtered.map(function (d) {
    return '<tr><td class="name">' + esc(d.material) + '</td><td>' + esc(d.tool) + '</td><td class="accent">' + esc(d.sfm) + '</td><td class="accent">' + esc(d.chipLoad) + '</td><td class="mono">' + esc(d.doc) + '</td><td class="mono">' + esc(d.woc) + '</td></tr>';
  }).join('');
  document.getElementById('gpm-cutting-empty').style.display = filtered.length ? 'none' : '';
}

function renderAll() { renderMaterials(); renderTools(); renderCuttingData(); }

document.addEventListener('DOMContentLoaded', function () {
  document.getElementById('gpm-lib-search').addEventListener('input', function (e) {
    state.search = e.target.value; renderAll();
  });
  document.getElementById('gpm-lib-category').addEventListener('change', function (e) {
    state.category = e.target.value; renderMaterials();
  });
  document.querySelectorAll('[data-tab-btn]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      state.tab = btn.getAttribute('data-tab-btn');
      document.querySelectorAll('[data-tab-btn]').forEach(function (b) { b.classList.toggle('active', b === btn); });
      document.querySelectorAll('.gpm-tab-panel').forEach(function (p) {
        p.classList.toggle('active', p.getAttribute('data-tab-panel') === state.tab);
      });
      document.getElementById('gpm-lib-category').style.display = state.tab === 'materials' ? '' : 'none';
    });
  });

  // Add custom material
  document.getElementById('gpm-add-material-form').addEventListener('submit', function (e) {
    e.preventDefault();
    var f = e.target;
    var name = f.elements['mat-name'].value.trim();
    if (!name) return;
    var mat = {
      id: GPM.nextId('material'),
      name: name,
      category: f.elements['mat-category'].value.trim() || 'Custom',
      hardness_hb: parseFloat(f.elements['mat-hardness'].value) || null,
      tensile_uts: parseFloat(f.elements['mat-uts'].value) || null,
      sfm_base: parseFloat(f.elements['mat-sfm'].value) || 300,
      chip_load_base: parseFloat(f.elements['mat-chipload'].value) || 0.002,
      sfm_range: f.elements['mat-sfm'].value ? f.elements['mat-sfm'].value + ' (base)' : '—',
      machinability: 'Custom',
      created_date: new Date().toISOString()
    };
    GPM.saveCustomMaterials([mat].concat(GPM.getCustomMaterials()));
    f.reset();
    renderMaterials();
  });

  renderAll();
});
})(window);
